import { t } from 'i18next';
import { RouteObject } from 'react-router-dom';
import { SetupFunctionClass } from './AttendanceClass/SetupFunctionClass';
import { ManualSynchronizationPage } from './ManualSynchronization/ManualSynchronizationPage';
import { SubstitutionsSetupPage } from './SubstituionsSetupPage';
import { SubstitutionAppSettingsPage } from './SubstitutionAppSettings/SubstitutionAppSettingsPage';
import { SubstitutionPlanSettingsPage } from './SubstitutionPlanSettings/SubstitutionPlanSettingsPage';

export const substitutionSetupRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      index: true,
      element: <SubstitutionsSetupPage />,
    },
    {
      path: t('routes.functionClass.slug'),
      element: <SetupFunctionClass />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.functionClass.slug')}`,
          title: t('routes.functionClass.title'),
        }),
      },
    },
    {
      path: t('routes.manualSynchronization.slug'),
      element: <ManualSynchronizationPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.manualSynchronization.slug')}`,
          title: t('routes.manualSynchronization.title'),
        }),
      },
    },
    {
      path: t('routes.substitutionPlanSettings.slug'),
      element: <SubstitutionPlanSettingsPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.substitutionPlanSettings.slug')}`,
          title: t('routes.substitutionPlanSettings.title'),
        }),
      },
    },
    {
      path: t('routes.substitutionAppSettings.slug'),
      element: <SubstitutionAppSettingsPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.substitutionAppSettings.slug')}`,
          title: t('routes.substitutionAppSettings.title'),
        }),
      },
    },
  ];
};
